import React from "react";
import Table from "react-bootstrap/Table";
import moment from "moment";
import "./DetaljiTable.css";
import { PaperClipOutlined, ZoomInOutlined } from "@ant-design/icons";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import RazlogBrisanjaComponent from "./RazlogBrisanjaComponent";

const SubjektZaObavljanjeRevUTrecojZemljiDetaljiTable = (props) => {
  // detalji za subjekta u trecoj zemlji
  let drustvo;
  let adresaDrustva;
  let registracijaDrustva = [];
  let kontaktDrustva;
  let osobaDrustvoZaSubjekta = [];
  let clanDrustva = [];
  let mreza = [];
  let clanMreze = [];
  let mjereDrustva = [];

  let ovlasteniRevizori = [];
  let regDrustvaOdobrenje = [];
  let dionicari = [];
  let upravaNadzor = [];
  let registracijaNadlTijelo = [];

  let registar = props.children;

  drustvo = registar[1];
  adresaDrustva = registar[2];
  registracijaDrustva = registar[3];
  kontaktDrustva = registar[4];
  osobaDrustvoZaSubjekta = registar[5];
  clanDrustva = registar[6];
  mreza = registar[7];
  clanMreze = registar[8];
  mjereDrustva = registar[10];

  ovlasteniRevizori = osobaDrustvoZaSubjekta.filter((x) => x.vrVeze == 1);

  regDrustvaOdobrenje = registracijaDrustva.filter(
    (x) => x.vrRegistracije == 1 && x.sifDrzave == 191
  );

  dionicari = clanDrustva.filter((x) => x.vrClana == 1);

  upravaNadzor = clanDrustva.filter((x) => x.vrClana == 2);

  registracijaNadlTijelo = registracijaDrustva.filter(
    (x) => x.vrRegistracije == 3
  );

  let nazivDrustva = drustvo.nazDrustva
    ? drustvo.nazDrustva
    : drustvo.ime + " " + drustvo.prezime;

  let clanoviMreze = clanMreze.filter((x) => x.vrClana === 1);
  let povezanaDrustva = clanMreze.filter((x) => x.vrClana === 2);

  // detalji za revizora u trecoj zemlji
  let osoba = props.children[11];
  let adresaOsobe = props.children[12];
  let registracijaOsobe = props.children[13];
  let osobaDrustvoZaRevizora = props.children[14];
  let dokumentOsobe = props.children[15];
  let mjeraOsoba = props.children[17];

  let registracijaOsobeOdobrenje = registracijaOsobe.filter(
    (x) => x.vrRegistracije == 1 && x.sifDrzave == 191
  );
  let registracijaOsobeUDrugojDrzavi = registracijaOsobe.filter(
    (x) => x.vrRegistracije == 2 || x.vrRegistracije == 3
  );

  const noDataMessage = "";

  const { userRole } = props;

  const checkIfUserIsAdmin =
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

  return (
    <div id="printArea">
      {drustvo.napomena ? (
        <RazlogBrisanjaComponent razlog={drustvo.napomena} />
      ) : null}
      <h5>Pregled podataka za subjekta</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">
              Naziv društva / ime i prezime samostalnog revizora
            </th>
            <th scope="col">
              {drustvo.idBroj ? "Identifikacijski broj" : "OIB"}
            </th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Pravni oblik</th>
            <th scope="col">
              Broj i datum registracije koju je odobrilo Ministarstvo financija
            </th>
            <th scope="col">Adresa</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{nazivDrustva}</td>
            <td>
              {drustvo.idBroj
                ? drustvo.idBroj
                : drustvo.oib
                ? drustvo.oib
                : noDataMessage}
            </td>
            <td>{drustvo.regBroj}</td>
            <td>{drustvo.pravniOblik}</td>
            <td className="hr-divider">
              {regDrustvaOdobrenje.map((element) => (
                <>
                  <table>
                    {!element.brReg && !element.datReg ? (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Izdavatelj: </b>
                            Hrvatska revizorska komora
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj odobrenja za rad: </b>
                            {element.brReg}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum odobrenja za rad: </b>
                            {element.datReg}
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                  <hr />{" "}
                </>
              ))}
            </td>
            <td>
              <table>
                <tbody>
                  <tr>
                    <td className="inner-td">
                      <b>Ulica i kbr: </b>
                      {adresaDrustva.ulicaKbr
                        ? adresaDrustva.ulicaKbr
                        : noDataMessage}
                    </td>
                  </tr>
                  {adresaDrustva.brPoste || adresaDrustva.nazNaselja ? (
                    <tr>
                      <td className="inner-td">
                        <b>Grad: </b>
                        {adresaDrustva.brPoste}
                        {adresaDrustva.nazNaselja &&
                          " " + adresaDrustva.nazNaselja}
                      </td>
                    </tr>
                  ) : null}
                  {adresaDrustva.drzava ? (
                    <tr>
                      <td className="inner-td">
                        <b>Država: </b>
                        {adresaDrustva.drzava}
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </Table>

      <h5>Podaci glavne osobe za kontakt</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Kontakt</th>
          </tr>
        </thead>
        <tbody>
          {!kontaktDrustva.ime &&
          !kontaktDrustva.telefon &&
          !kontaktDrustva.web &&
          !kontaktDrustva.email ? (
            <tr>
              <td></td>
            </tr>
          ) : (
            <tr>
              <td x-ms-format-detection="none">
                <div>
                  {kontaktDrustva.ime ? kontaktDrustva.ime : null}{" "}
                  {kontaktDrustva.prezime ? kontaktDrustva.prezime : null}
                </div>
                <div>
                  {kontaktDrustva.telefon ? (
                    <>
                      <b>telefon: </b>
                      {kontaktDrustva.telefon}
                    </>
                  ) : null}
                </div>
                <div>
                  {kontaktDrustva.web ? (
                    <>
                      <b>web: </b>
                      {kontaktDrustva.web}
                    </>
                  ) : null}
                </div>
                <div>
                  {kontaktDrustva.email ? (
                    <>
                      <b>email: </b>
                      {kontaktDrustva.email}
                    </>
                  ) : null}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Ovlašteni revizori koji su zaposleni u revizorskom društvu / kod
        samostalnog revizora, ili su s njime povezani kao partner ili na drugi
        način
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Registarski broj</th>
            {/* <th scope="col">Detalji</th> */}
          </tr>
        </thead>
        <tbody>
          {ovlasteniRevizori.length > 0 ? (
            ovlasteniRevizori.map((ovlasteniRevizor, index) => (
              <tr key={`ovlasteni-revizor${index}`}>
                <td>
                  {ovlasteniRevizor.imeOsobe} {ovlasteniRevizor.prezimeOsobe}
                </td>
                <td>{ovlasteniRevizor.regBrojOsobe}</td>
              </tr>
            ))
          ) : (
            <tr key={`ovlasteni-revizor`}>
              <td colSpan="2"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Članovi / dioničari društva</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv društva / Ime i prezime</th>
            <th scope="col">Poslovna adresa</th>
          </tr>
        </thead>
        <tbody>
          {dionicari.length > 0 ? (
            dionicari.map((dionicar, index) => (
              <tr key={`clanovi-dionicari${index}`}>
                <td>
                  {dionicar.naziv
                    ? dionicar.naziv
                    : dionicar.ime && dionicar.prezime
                    ? +" " + dionicar.prezime
                    : noDataMessage}
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Ulica i kbr: </b>
                          {dionicar.ulicaKbr
                            ? dionicar.ulicaKbr
                            : noDataMessage}
                        </td>
                      </tr>
                      {dionicar.brPoste || dionicar.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {dionicar.brPoste}
                            {dionicar.nazNaselja && " " + dionicar.nazNaselja}
                          </td>
                        </tr>
                      ) : null}
                      {dionicar.drzava ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {dionicar.drzava}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
              </tr>
            ))
          ) : (
            <tr key={`clanovi-dionicari`}>
              <td colSpan="2"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Uprava / upravni odbor</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            <th scope="col">Funkcija</th>
            <th scope="col">Poslovna adresa</th>
          </tr>
        </thead>
        <tbody>
          {upravaNadzor.length > 0 ? (
            upravaNadzor.map((uprava, index) => (
              <tr key={`uprava-nadzor${index}`}>
                <td>
                  {uprava.ime} {uprava.prezime}
                  {checkIfUserIsAdmin && uprava.oib
                    ? " (" + uprava.oib + ")"
                    : null}
                </td>
                <td>{uprava.funkcija}</td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Ulica i kbr: </b>
                          {uprava.ulicaKbr ? uprava.ulicaKbr : noDataMessage}
                        </td>
                      </tr>
                      {uprava.brPoste || uprava.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {uprava.brPoste}
                            {uprava.nazNaselja && " " + uprava.nazNaselja}
                          </td>
                        </tr>
                      ) : null}
                      {uprava.drzava ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {uprava.drzava}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
              </tr>
            ))
          ) : (
            <tr key={`uprava-nadzor`}>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Revizorske mreže / članovi mreže / povezana društva</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv i sjedište mreže</th>
            <th scope="col">Adrese članova mreže</th>
            <th scope="col">Povezana društva i adrese</th>
            <th scope="col">web adresa</th>
          </tr>
        </thead>
        <tbody>
          {!mreza.nazMreze &&
          !mreza.ulicaKbr &&
          !mreza.brPoste &&
          !mreza.nazNaselja &&
          !clanMreze.length > 0 ? (
            <tr>
              <td colSpan="4"></td>
            </tr>
          ) : (
            <tr>
              {!mreza.nazMreze &&
              !mreza.ulicaKbr &&
              !mreza.brPoste &&
              !mreza.nazNaselja ? (
                <td></td>
              ) : (
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Naziv mreže: </b>
                          {mreza.nazMreze ? mreza.nazMreze : noDataMessage}
                        </td>
                      </tr>
                      <tr>
                        <td className="inner-td">
                          <b>Ulica i kbr: </b>
                          {mreza.ulicaKbr ? mreza.ulicaKbr : noDataMessage}
                        </td>
                      </tr>
                      {mreza.brPoste || mreza.nazNaselja ? (
                        <tr>
                          <td className="inner-td">
                            <b>Grad: </b>
                            {mreza.brPoste}
                            {mreza.nazNaselja && " " + mreza.nazNaselja}
                          </td>
                        </tr>
                      ) : null}
                      {mreza.nazDrzave ? (
                        <tr>
                          <td className="inner-td">
                            <b>Država: </b>
                            {mreza.nazDrzave}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
              )}
              <td className="hr-divider">
                {clanoviMreze.length > 0
                  ? clanoviMreze.map((clanMreza, index) => (
                      <>
                        <table key={`clanovi-mreze${index}`}>
                          <tbody>
                            <tr>
                              <td className="inner-td">
                                <b>Naziv mreže: </b>
                                {clanMreza.nazMreze
                                  ? clanMreza.nazMreze
                                  : noDataMessage}
                              </td>
                            </tr>
                            <tr>
                              <td className="inner-td">
                                <b>Ulica i kbr: </b>
                                {clanMreza.ulicaKbr
                                  ? clanMreza.ulicaKbr
                                  : noDataMessage}
                              </td>
                            </tr>
                            {clanMreza.brPoste || clanMreza.nazNaselja ? (
                              <tr>
                                <td className="inner-td">
                                  <b>Grad: </b>
                                  {clanMreza.brPoste}
                                  {clanMreza.nazNaselja &&
                                    " " + clanMreza.nazNaselja}
                                </td>
                              </tr>
                            ) : null}
                            {clanMreza.nazDrzave ? (
                              <tr>
                                <td className="inner-td">
                                  <b>Država: </b>
                                  {clanMreza.nazDrzave}
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                        <hr />
                      </>
                    ))
                  : null}
              </td>
              <td className="hr-divider">
                {povezanaDrustva.length > 0
                  ? povezanaDrustva.map((povezanoDrustvo, index) => (
                      <>
                        <table key={`povezana-drustva${index}`}>
                          <tbody>
                            <tr>
                              <td className="inner-td">
                                <b>Naziv društva: </b>
                                {povezanoDrustvo.nazDrustva
                                  ? povezanoDrustvo.nazDrustva
                                  : noDataMessage}
                              </td>
                            </tr>
                            <tr>
                              <td className="inner-td">
                                <b>Ulica i kbr: </b>
                                {povezanoDrustvo.ulicaKbr
                                  ? povezanoDrustvo.ulicaKbr
                                  : noDataMessage}
                              </td>
                            </tr>
                            {povezanoDrustvo.brPoste ||
                            povezanoDrustvo.nazNaselja ? (
                              <tr>
                                <td className="inner-td">
                                  <b>Grad: </b>
                                  {povezanoDrustvo.brPoste}
                                  {povezanoDrustvo.nazNaselja &&
                                    " " + povezanoDrustvo.nazNaselja}
                                </td>
                              </tr>
                            ) : null}
                            {povezanoDrustvo.nazDrzave ? (
                              <tr>
                                <td className="inner-td">
                                  <b>Država: </b>
                                  {povezanoDrustvo.nazDrzave}
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                        <hr />
                      </>
                    ))
                  : null}
              </td>
              <td>
                {clanMreze.map((cm, index) => (
                  <table key={`clan-mrezeid${index}`}>
                    <tbody>
                      <tr>
                        <td className="focusable inner-td">
                          <a href={"http://" + cm.web} target="_blank">
                            {cm.web}
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ))}
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>
        Registracija kod nadležnih tijela drugih država članica i trećih zemalja
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum registracije</th>
          </tr>
        </thead>
        <tbody>
          {registracijaNadlTijelo.length > 0 ? (
            registracijaNadlTijelo.map((reg, index) =>
              !reg.brReg &&
              !reg.datReg &&
              !reg.nazTijela &&
              !reg.ulicaKbr &&
              !reg.brPoste &&
              !reg.nazNaselja ? (
                <tr key={`registracija-nadl-tijela${index}`}>
                  <td colSpan="3"></td>
                </tr>
              ) : (
                <tr key={`registracija-nadl-tijela${index}`}>
                  <td>{reg.nazTijela ? reg.nazTijela : noDataMessage}</td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {reg.ulicaKbr ? reg.ulicaKbr : noDataMessage}
                          </td>
                        </tr>
                        {reg.brPoste || reg.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {reg.brPoste}
                              {reg.nazNaselja && " " + reg.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {reg.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {reg.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj registracije: </b>
                            {reg.brReg ? reg.brReg : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum registracije: </b>
                            {reg.datReg ? reg.datReg : noDataMessage}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr key={`registracija-nadl-tijela`}>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Izrečene odluke i nadzorne mjere za subjekta</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Vrsta mjere</th>
            <th scope="col">Rješenje</th>
            <th scope="col">Broj i datum rješenja</th>
            {checkIfUserIsAdmin ? (
              <th scope="col">Datum dostave rješenja subjektu</th>
            ) : null}
            {/* <th scope="col">Napomena</th> */}
            <th scope="col">Upravni spor</th>
            <th scope="col">Datum pravomoćnosti</th>
            <th scope="col">Prekršajni postupak</th>
            {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
              <th scope="col">Datum brisanja</th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {mjereDrustva.length ? (
            mjereDrustva.map((mjera, index) => (
              <tr key={`mjere-drustva${index}`}>
                <td>{mjera.vrstaMjere ? mjera.vrstaMjere : noDataMessage}</td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentDrustvo(e, mjera.idMjereDrustva)
                    }
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>

                  <table>
                    <tbody>
                      {mjera.napomena ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Broj rješenja: </b>
                          {mjera.brRjesenja ? mjera.brRjesenja : noDataMessage}
                        </td>
                      </tr>
                      <tr>
                        <td className="inner-td">
                          <b>Datum rješenja: </b>
                          {mjera.datRjesenja
                            ? mjera.datRjesenja
                            : noDataMessage}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin ? (
                  <td>
                    {mjera.datPreuzimanja
                      ? mjera.datPreuzimanja
                      : noDataMessage}
                  </td>
                ) : null}
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentUSDrustvo(e, mjera.idMjereDrustva)
                    }
                    disabled={mjera.nazivDok2 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>

                  <table>
                    <tbody>
                      {mjera.napomena2 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena2}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  {mjera.datPravomocnosti
                    ? mjera.datPravomocnosti
                    : noDataMessage}
                </td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentPPDrustvo(e, mjera.idMjereDrustva)
                    }
                    disabled={mjera.nazivDok3 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena3 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena3}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin || userRole === "ROLE_KORISNIK" ? (
                  <td>
                    {mjera.datBrisanja ? mjera.datBrisanja : noDataMessage}
                  </td>
                ) : null}
              </tr>
            ))
          ) : (
            <tr key={`mjere-drustva`}>
              <td colSpan="8"></td>
            </tr>
          )}
        </tbody>
      </Table>
      <hr style={{ marginBottom: "45px" }}></hr>

      <h5>Pregled podataka za revizora</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Ime i prezime</th>
            {checkIfUserIsAdmin ? (
              <th scope="col">
                {osoba.idBroj ? "Identifikacijski broj" : "OIB"}
              </th>
            ) : null}
            <th scope="col">Registarski broj</th>
            <th scope="col">
              Broj i datum registracije odobrene od Ministarstva financija
            </th>
            <th scope="col">Adresa</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {osoba.ime} {osoba.prezime}
            </td>
            {checkIfUserIsAdmin ? (
              <td>
                {osoba.idBroj
                  ? osoba.idBroj
                  : osoba.oib
                  ? osoba.oib
                  : noDataMessage}
              </td>
            ) : null}
            <td>{osoba.regBroj}</td>
            <td className="hr-divider">
              {registracijaOsobeOdobrenje.map((element) => (
                <>
                  <table>
                    {!element.brReg && !element.datReg ? (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Izdavatelj: </b>
                            Hrvatska revizorska komora
                          </td>
                        </tr>
                      </tbody>
                    ) : (
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj odobrenja za rad: </b>
                            {element.brReg}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum odobrenja za rad: </b>
                            {element.datReg}
                          </td>
                        </tr>
                      </tbody>
                    )}
                  </table>
                  <hr />{" "}
                </>
              ))}
            </td>
            <td>
              <table>
                <tbody>
                  <tr>
                    <td className="inner-td">
                      <b>Ulica i kbr: </b>
                      {adresaOsobe.ulicaKbr
                        ? adresaOsobe.ulicaKbr
                        : noDataMessage}
                    </td>
                  </tr>
                  {adresaOsobe.brPoste || adresaOsobe.nazNaselja ? (
                    <tr>
                      <td className="inner-td">
                        <b>Grad: </b>
                        {adresaOsobe.brPoste}
                        {adresaOsobe.nazNaselja && " " + adresaOsobe.nazNaselja}
                      </td>
                    </tr>
                  ) : null}
                  {adresaOsobe.drzava ? (
                    <tr>
                      <td className="inner-td">
                        <b>Država: </b>
                        {adresaOsobe.drzava}
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </Table>

      <h5>
        Podaci o revizorskom društvu / samostalnom revizoru kod kojega je
        revizor zaposlen ili povezan kao partner ili na neki drugi način
      </h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">
              Naziv društva / ime i prezime samostalnog revizora
            </th>
            <th scope="col">Registarski broj</th>
            <th scope="col">Adresa</th>
            <th scope="col">Internetska stranica</th>
          </tr>
        </thead>
        <tbody>
          {osobaDrustvoZaRevizora.idDrustva !== null ? (
            <tr>
              <td>
                {osobaDrustvoZaRevizora.nazivDrustva
                  ? osobaDrustvoZaRevizora.nazivDrustva
                  : osobaDrustvoZaRevizora.imeDrustva +
                    " " +
                    osobaDrustvoZaRevizora.prezimeDrustva}
              </td>
              <td>{osobaDrustvoZaRevizora.regBrojDrustva}</td>
              <td>
                <table>
                  <tbody>
                    <tr>
                      <td className="inner-td">
                        <b>Ulica i kbr: </b>
                        {osobaDrustvoZaRevizora.ulicaKbrDrustva
                          ? osobaDrustvoZaRevizora.ulicaKbrDrustva
                          : noDataMessage}
                      </td>
                    </tr>

                    {osobaDrustvoZaRevizora.postanskiBrojDrustva ||
                    osobaDrustvoZaRevizora.nazivNaseljaDrustva ||
                    osobaDrustvoZaRevizora.gradDrustva ? (
                      <tr>
                        <td className="inner-td">
                          <b>Grad: </b>
                          {osobaDrustvoZaRevizora.postanskiBrojDrustva}
                          {osobaDrustvoZaRevizora.nazivNaseljaDrustva &&
                            " " + osobaDrustvoZaRevizora.nazivNaseljaDrustva}
                          {osobaDrustvoZaRevizora.gradDrustva &&
                            ", " + osobaDrustvoZaRevizora.gradDrustva}
                        </td>
                      </tr>
                    ) : null}
                    {osobaDrustvoZaRevizora.nazDrzaveDrustva ? (
                      <tr>
                        <td className="inner-td">
                          <b>Država: </b>
                          {osobaDrustvoZaRevizora.nazDrzaveDrustva}
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </td>
              <td>
                {osobaDrustvoZaRevizora.web ? (
                  <a
                    href={"http://" + osobaDrustvoZaRevizora.web}
                    target="_blank"
                  >
                    {osobaDrustvoZaRevizora.web}
                  </a>
                ) : (
                  noDataMessage
                )}
              </td>
            </tr>
          ) : (
            <tr>
              <td colSpan="4"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Registracija kod drugih država članica i trećih zemalja</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Naziv nadležnog tijela</th>
            <th scope="col">Adresa nadležnog tijela</th>
            <th scope="col">Broj i datum registracije</th>
          </tr>
        </thead>
        <tbody>
          {registracijaOsobeUDrugojDrzavi.length > 0 ? (
            registracijaOsobeUDrugojDrzavi.map((regDrDrz, index) =>
              !regDrDrz.brReg &&
              !regDrDrz.datReg &&
              !regDrDrz.nazTijela &&
              !regDrDrz.ulicaKbr &&
              !regDrDrz.brPoste &&
              !regDrDrz.nazNaselja ? (
                <tr key={`registracija-osobe-u-dr-drz${index}`}>
                  <td colSpan="3"></td>
                </tr>
              ) : (
                <tr key={`registracija-osobe-u-dr-drz${index}`}>
                  <td>
                    {regDrDrz.nazTijela ? regDrDrz.nazTijela : noDataMessage}
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Ulica i kbr: </b>
                            {regDrDrz.ulicaKbr
                              ? regDrDrz.ulicaKbr
                              : noDataMessage}
                          </td>
                        </tr>
                        {regDrDrz.brPoste || regDrDrz.nazNaselja ? (
                          <tr>
                            <td className="inner-td">
                              <b>Grad: </b>
                              {regDrDrz.brPoste}
                              {regDrDrz.nazNaselja && " " + regDrDrz.nazNaselja}
                            </td>
                          </tr>
                        ) : null}
                        {regDrDrz.nazivDrzave ? (
                          <tr>
                            <td className="inner-td">
                              <b>Država: </b>
                              {regDrDrz.nazivDrzave}
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table>
                      <tbody>
                        <tr>
                          <td className="inner-td">
                            <b>Broj registracije: </b>
                            {regDrDrz.brReg ? regDrDrz.brReg : noDataMessage}
                          </td>
                        </tr>
                        <tr>
                          <td className="inner-td">
                            <b>Datum registracije: </b>
                            {regDrDrz.datReg ? regDrDrz.datReg : noDataMessage}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )
            )
          ) : (
            <tr key={`registracija-osobe-u-dr-drz`}>
              <td colSpan="3"></td>
            </tr>
          )}
        </tbody>
      </Table>

      <h5>Izrečene odluke i nadzorne mjere za revizora</h5>
      <Table responsive bordered hover>
        <thead>
          <tr className="tr_table">
            <th scope="col">Vrsta mjere</th>
            <th scope="col">Rješenje</th>
            <th scope="col">Broj i datum rješenja</th>
            {checkIfUserIsAdmin ? (
              <th scope="col">Datum dostave rješenja subjektu</th>
            ) : null}
            {/* <th scope="col">Napomena</th> */}
            <th scope="col">Upravni spor</th>
            <th scope="col">Datum pravomoćnosti</th>
            <th scope="col">Prekršajni postupak</th>
            {checkIfUserIsAdmin ? <th scope="col">Datum brisanja</th> : null}
          </tr>
        </thead>
        <tbody>
          {mjeraOsoba.length ? (
            mjeraOsoba.map((mjera, index) => (
              <tr key={`mjera-osoba${index}`}>
                <td>{mjera.vrstaMjere ? mjera.vrstaMjere : noDataMessage}</td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentOsoba(e, mjera.idMjereOsobe)
                    }
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  <table>
                    <tbody>
                      <tr>
                        <td className="inner-td">
                          <b>Broj rješenja: </b>
                          {mjera.brRjesenja ? mjera.brRjesenja : noDataMessage}
                        </td>
                      </tr>
                      <tr>
                        <td className="inner-td">
                          <b>Datum rješenja: </b>
                          {mjera.datRjesenja
                            ? mjera.datRjesenja
                            : noDataMessage}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin ? (
                  <td>
                    {mjera.datPreuzimanja
                      ? mjera.datPreuzimanja
                      : noDataMessage}
                  </td>
                ) : null}
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentUSOsoba(e, mjera.idMjereOsobe)
                    }
                    disabled={mjera.nazivDok2 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>

                  <table>
                    <tbody>
                      {mjera.napomena2 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena2}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                <td>
                  {mjera.datPravomocnosti
                    ? mjera.datPravomocnosti
                    : noDataMessage}
                </td>
                <td className="ikona_dokument_td ant_batn">
                  <ButtonComponent
                    className="ikona_dokument"
                    variant="secondary"
                    onClick={(e) =>
                      props.downloadDocumentPPOsoba(e, mjera.idMjereOsobe)
                    }
                    disabled={mjera.nazivDok3 ? false : true}
                  >
                    <PaperClipOutlined />
                  </ButtonComponent>
                  <table>
                    <tbody>
                      {mjera.napomena3 ? (
                        <tr>
                          <td className="inner-td">
                            <b>Napomena: </b>
                            {mjera.napomena3}
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </td>
                {checkIfUserIsAdmin ? (
                  <td>
                    {mjera.datBrisanja ? mjera.datBrisanja : noDataMessage}
                  </td>
                ) : null}
              </tr>
            ))
          ) : (
            <tr key={`mjera-osoba`}>
              <td colSpan="8"></td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default SubjektZaObavljanjeRevUTrecojZemljiDetaljiTable;
